import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export default function Empresas({
  empresas,
  isConsultaNova,
}: {
  empresas: any;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();

  if (isConsultaNova) {
    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              backgroundColor: '#EFF6FF',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i className="pi pi-building" style={{ color: '#2563EB', fontSize: '18px' }} />
          </div>
          <div>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>
              {t('participacaoEmpresa')}
            </h3>
            {empresas?.length > 0 && (
              <span style={{ fontSize: 'small', color: '#6B7280' }}>
                {empresas.length} empresa{empresas.length !== 1 ? 's' : ''}
              </span>
            )}
          </div>
        </div>

        <div style={{ overflowX: 'auto', borderRadius: '10px', border: '1px solid #F3F4F6' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: 'small' }}>
            <thead>
              <tr style={{ backgroundColor: '#F9FAFB', borderBottom: '2px solid #E5E7EB' }}>
                {[t('cnpj'), t('status'), t('razaoSocial'), t('tipo'), t('participacao'), t('valorParticipacao'), t('dataEntrada'), t('dataAtualizacao')].map(h => (
                  <th
                    key={h}
                    style={{
                      padding: '10px 14px',
                      fontWeight: 700,
                      color: '#6B7280',
                      fontSize: '0.7rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.04em',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {empresas && empresas.map((e: any, idx: number) => (
                <tr
                  key={idx}
                  style={{ borderBottom: idx < empresas.length - 1 ? '1px solid #F3F4F6' : 'none' }}
                  onMouseEnter={ev => (ev.currentTarget.style.backgroundColor = '#EFF6FF')}
                  onMouseLeave={ev => (ev.currentTarget.style.backgroundColor = 'transparent')}
                >
                  <td style={{ padding: '10px 14px', fontFamily: 'monospace', color: '#374151' }}>{e.cnpj}</td>
                  <td style={{ padding: '10px 14px' }}>
                    <span
                      style={{
                        backgroundColor: e.status === 'A' || e.status === 'ATIVO' ? '#DCFCE7' : '#FEF3C7',
                        color: e.status === 'A' || e.status === 'ATIVO' ? '#15803D' : '#B45309',
                        fontSize: '0.7rem',
                        fontWeight: 700,
                        padding: '2px 8px',
                        borderRadius: '4px',
                      }}
                    >
                      {e.status}
                    </span>
                  </td>
                  <td style={{ padding: '10px 14px', fontWeight: 600, color: '#1F2937' }}>{e.nome}</td>
                  <td style={{ padding: '10px 14px', color: '#374151' }}>{e.tipo}</td>
                  <td style={{ padding: '10px 14px', color: '#374151' }}>{e.participacao}</td>
                  <td style={{ padding: '10px 14px', color: '#374151' }}>{e.valorParticipacao ?? '—'}</td>
                  <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{e.dataInicio}</td>
                  <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{e.dataAtualizacao}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <Panel header={t('participacaoEmpresa')}>
      <DataTable size="small" value={empresas} tableStyle={{ minWidth: '50rem' }}>
        <Column field="cnpj" header={t('cnpj')}></Column>
        <Column field="status" header={t('status')}></Column>
        <Column field="nome" header={t('razaoSocial')}></Column>
        <Column field="tipo" header={t('tipo')}></Column>
        <Column field="participacao" header={t('participacao')}></Column>
        <Column field="valorParticipacao" header={t('valorParticipacao')}></Column>
        <Column field="nivelConfianca" header={t('nivelConfianca')}></Column>
        <Column field="trabalhoPrincipal" header={t('trabalhoPrincipal')}></Column>
        <Column field="dataInicio" header={t('dataEntrada')}></Column>
        <Column field="dataAtualizacao" header={t('dataAtualizacao')}></Column>
      </DataTable>
    </Panel>
  );
}
